// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__yAdj-","header":"Messages_header__3Ul6j"};